
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pod-cafe",
      function () {
        return require("private-next-pages/pod-cafe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pod-cafe"])
      });
    }
  